import React from "react";
import styles from "./InputDesign.module.css";

function FontInput({
  label,
  nameValue,
  locationValue,
  onNameChange,
  onLocationChange,
}) {
  const loadFont = async () => {
    if (!nameValue || !locationValue) {
      alert("Veuillez remplir le nom et l'URL de la police");
      return;
    }

    try {
      if (locationValue.includes('fonts.googleapis.com')) {
        // Pour les polices Google Fonts
        const link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = locationValue;
        document.head.appendChild(link);
        alert("Police Google Fonts chargée avec succès !");
      } else {
        // Pour les polices locales (.ttf)
        const style = document.createElement('style');
        style.textContent = `
          @font-face {
            font-family: '${nameValue}';
            src: url('${locationValue}') format('truetype');
            font-display: swap;
          }
        `;
        document.head.appendChild(style);

        const font = new FontFace(nameValue, `url(${locationValue})`);
        await font.load();
        document.fonts.add(font);
        alert("Police locale chargée avec succès !");
      }
    } catch (error) {
      console.error("Erreur lors du chargement de la police:", error);
      alert("Erreur lors du chargement de la police");
    }
  };

  return (
    <div className={styles.fontInputContainer}>
      <label className={styles.inputLabel}>{label}</label>
      <div className={styles.fontInputWrapper}>
        <input
          type="text"
          placeholder="Font Name"
          className={styles.fontInput}
          value={nameValue}
          onChange={(e) => onNameChange(e.target.value)}
          aria-label={`${label} name`}
        />
        <input
          type="text"
          placeholder="Font URL"
          className={styles.fontUrl}
          value={locationValue}
          onChange={(e) => onLocationChange(e.target.value)}
          aria-label={`${label} URL`}
        />
        <button 
          onClick={loadFont}
          className={styles.primaryButton}
          style={{ 
            padding: "8px 16px",
            marginLeft: "8px"
          }}
        >
          Charger la police
        </button>
      </div>
    </div>
  );
}

export default FontInput;
